import { useEffect, useState } from 'react';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FeedbackModal } from './FeedbackModal';
import { SideTab } from '@/components/SideTab';

const TOOLTIP = 'Report a bug, suggest an idea, or share a reaction — Ctrl+Shift+F';

export function FeedbackButton() {
  const enabled = useFeatureFlag('feedback_enabled');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      const mod = e.ctrlKey || e.metaKey;
      if (mod && e.shiftKey && (e.key === 'F' || e.key === 'f')) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <>
      <SideTab
        label="Send Feedback"
        title={TOOLTIP}
        accent="mono"
        badge="amber"
        bottom={120}
        onClick={() => setOpen(true)}
      />
      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
